import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography/Typography";
import SectionHeader from "../UI/SectionHeader";
import { formatPhone } from "../../utilities/format";
import { AppTheme } from "../../theme";
import { connect } from "react-redux";

const headerStyles = {
  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  fontWeight: 500,
  marginBottom: 10,
  color: AppTheme.palette.grey[800],
};
const styles = (theme) => ({
  printOnlyCoverPage: {
    display: "none",
    "@media print": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100vh",
      pageBreakAfter: "always",
    },
  },
  pid: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  logo: {
    width: 300,
    marginBottom: 60,
  },
  content: {
    minWidth: 350,
  },
  header: {
    ...headerStyles,
    fontSize: 50,
  },
  draftHeader: {
    ...headerStyles,
  },
  contentText: {
    fontSize: 20,
  },
  bottomSpacing: {
    marginBottom: 20,
  },
});

const SummaryPDFCoverPage = ({
  classes,
  isDraft,
  advisors,
  clients,
  portfolioId,
  portfolioName,
  scenarioName,
  logo,
  appName,
}) => {
  // Build a mapping containing the primary and non-primary contact. Example:
  // {
  //   primary: { id: 3, profile: { ... } },
  //   secondary: { id: 4, profile: { ... } },
  // }
  const clientMap = clients.reduce((acc, client) => {
    return {
      ...acc,
      [client.profile.primary ? "primary" : "secondary"]: client,
    };
  }, {});

  return (
    <div className={classes.printOnlyCoverPage}>
      <Typography variant={"body1"} className={classes.pid}>
        {portfolioId ? `Portfolio ID: ${portfolioId}` : `Default Portfolio`}
      </Typography>

      <div>
        { logo && <img className={classes.logo} alt="Logo" src={`data:image/svg+xml;base64, ${logo}`} /> }
      </div>
      <div className={classes.content}>
        <Typography variant="h2" className={classes.header}>
          Portfolio Summary
        </Typography>
        {portfolioName && (
          <Typography
            variant="h4"
            align="center"
            className={classes.draftHeader}
          >
            {portfolioName}
          </Typography>
        )}
        <div className={classes.bottomSpacing}>
          <SectionHeader text="Advisor" />
          {advisors.map((advisor) => {
            return (
              <span key={advisor.email}>
                <Typography variant="body2" className={classes.contentText}>
                  <strong>
                    {advisor.first_name} {advisor.last_name}
                  </strong>
                </Typography>
                {advisor.fullAddress && (
                  <Typography variant="body2" className={classes.contentText}>
                    <span style={{ whiteSpace: "pre-line" }}>
                      {advisor.fullAddress}
                    </span>
                  </Typography>
                )}
                {advisor.phone && (
                  <Typography variant="body2" className={classes.contentText}>
                    Phone: {formatPhone(advisor.phone)}
                  </Typography>
                )}
                <Typography variant="body2" className={classes.contentText}>
                  Email: {advisor.email}
                </Typography>
              </span>
            );
          })}
        </div>
        <div>
          <SectionHeader text="Client" />
          {clientMap.primary && (
            <Typography variant="body2" className={classes.contentText}>
              <strong>
                {clientMap.primary.profile.firstName}{" "}
                {clientMap.primary.profile.lastName}
              </strong>
            </Typography>
          )}
          {clientMap.secondary && (
            <Typography variant="body2" className={classes.contentText}>
              {clientMap.secondary.profile.firstName}{" "}
              {clientMap.secondary.profile.lastName}
            </Typography>
          )}
          {clientMap.primary && (
            <React.Fragment>
              {clientMap.primary.profile.phone && (
                <Typography variant="body2" className={classes.contentText}>
                  Phone: {formatPhone(clientMap.primary.profile.phone)}
                </Typography>
              )}
              {clientMap.primary.profile.email && (
                <Typography variant="body2" className={classes.contentText}>
                  Email: {clientMap.primary.profile.email}
                </Typography>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};
SummaryPDFCoverPage.propTypes = {
  classes: PropTypes.object.isRequired,
  isDraft: PropTypes.bool,
  advisors: PropTypes.array.isRequired,
  clients: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
  return {
    logo: state.app.logo,
    appName: state.app.appName,
  };
};

export default withStyles(styles)(
  connect(mapStateToProps)(SummaryPDFCoverPage)
);



// WEBPACK FOOTER //
// ./src/components/Content/SummaryPDFCoverPage.jsx